import { Component } from '@angular/core';

@Component({
  selector: 'lib-hyper-base-ng',
  imports: [],
  templateUrl: './hyper-base-ng.html',
  styleUrl: './hyper-base-ng.scss',
})
export class HyperBaseNg {}
